<template>
  <div class="home">
    <div class="head-title">金额记录</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <nav class="navbar">
            <div class="nav-l">
              <el-select
                clearable
                v-model="value"
                placeholder="请选择变动类型"
                @change="onSubmit"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </nav>
          <el-table
            :data="tableData.data"
            
            border
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            style="width: 100%; text-aligh: center; margin-top: 2.0rem"
          >
            <el-table-column
              prop="type"
              label="变动类型"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="money"
              label="金额"
              style="width: 20%"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="content"
              label="说明"
              style="width: 40%"
              show-overflow-tooltip=""
            ></el-table-column>
            <el-table-column
              prop="addtime"
              label="变动时间"
              style="width: 20%"
              width="200"
            ></el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="abc"
            />
          </div>
          <!-- <img src="uploads\\20200425\\068e9ca31ccfa3a225ec751925a3eaa2.jpg" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      url: "https://api.weijub.com",
      username: {},
      title: {},
      czphone: "",
      options: {},
      value: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.abc();
  },
  methods: {
    onSubmit() {
      this.abc();
    },
    // tooken验证
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/record/getRecordList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: val,
            type: this.value,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    abc() {
      this.axios
        .post(
          "/api/Agent/getMoneyRecord",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            type: this.value,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
      this.axios
        .post(
          "/api/Agent/getMoneyRecordSearch",
          qs.stringify({
            parent_id: this.username.parent_id,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.options = res.data.data;
        })
        .catch(function (err) {});
    },

    // 提交过后输出的数据\
    transignificance(val, type) {
      for (const key in type) {
        if (key * 1 === val) {
          return type[key];
        }
      }
    },
  },
  // 1.用户分配
};
</script>
<style scoped>
h1 {
  font-size: 26px;
  font-weight: 500;
  color: #393939;
  font-family: "黑软雅黑";
}

.el-table .thea {
  color: #333333;
  font-size: 18px;
}
.el-dialog__header {
  /* height: 69px; */
  background-color: #2890dd;
}
.el-dialog__title {
  color: #ffffff !important;
  /* font-size: 2.0rem !important; */
}
.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #FFFFFF;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 31px;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.tianjia > main {
  font-size: 26px;
  /* margin-bottom: 4.0rem; */
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.el-form-item {
  display: inline-block;
}
</style>


